var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelicopter = function SvgHelicopter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.077 13.461V7.154q-2.884 0-4.596 1.904Q3.77 10.962 3.77 13.46zm3.385 3.385V7.154h-2.385v7.307H3.77v1.77q0 .268.173.442a.6.6 0 0 0 .442.173zm1-3.162 5.769-.6V11h-5.77zm-1.712 6.547H4v-1h8.75zm1.712-2.385H4.385q-.667 0-1.141-.474a1.56 1.56 0 0 1-.474-1.142v-2.769q0-2.927 2.007-5.117t5.3-2.19h4.385V10h4.884l.885-2h1v5.98l-6.77.704zM18.75 4.769H4v-1h14.75z"
  })));
};
export default SvgHelicopter;